import React from 'react'
import { BabbelThemeProvider } from 'src/viewLayer/components/DesignSystem'

// The following wrappers are to disable dark mode for web until it has been implemented in the rest of the company
const BabbelThemeProviderWeb = ({ children }) => (
  <BabbelThemeProvider defaultMode="light">{children}</BabbelThemeProvider>
)

const BabbelThemeProviderMobile = ({ children }) => (
  <BabbelThemeProvider defaultMode="system">{children}</BabbelThemeProvider>
)

export { BabbelThemeProviderMobile, BabbelThemeProviderWeb }
